import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { BtnAlternative, BtnPrimary } from '../buttons/Btn';
import Register from '../register/Register';
import { useAuth } from '../../../Context/AuthContext';

const LoginLayout = () => {
	const [login, setLogin] = useState(true);
	const [signIn, setSignIn] = useState(false);
	const [modalShow, setModalShow] = useState(false);

	const { authRefDispatch, authAccDispatch, authUserDispatch, authUser } =
		useAuth();
	function showModal(e) {
		if (e.target.id === 'btn-primary') {
			setLogin(false);
			setSignIn(true);
			setModalShow(true);
		} else {
			setLogin(true);
			setSignIn(false);
			setModalShow(true);
		}
	}

	const logout = () => {
		authRefDispatch({
			type: 'LOGOUT',
		});

		authAccDispatch({
			type: 'LOGOUT',
		});

		authUserDispatch({
			type: 'LOGOUT',
		});
	};
	return (
		<>
			<div className='navbar__login flex md:order-2'>
				{Cookies.get('username') ? (
					<div className='flex justify-center items-center'>
						<span className='py-2 pr-4 pl-3 text-[1.4rem]'>
							{Cookies.get('username')}
						</span>
						<BtnAlternative
							text='خروج'
							onClick={logout}
							className='mx-2 py-3 px-9'
						/>
					</div>
				) : (
					<>
						<BtnAlternative
							text='ورود'
							className='mx-3 py-5 px-12 rounded-3xl'
							onClick={showModal}
						/>
						<BtnPrimary
							text='رایگان ثبت نام کنید!'
							className='mx-1 py-5 px-7 hover:animate-btnBeat rounded-3xl navbar__login--register'
							onClick={showModal}
						/>
					</>
				)}
			</div>
			{modalShow && (
				<Register
					modalShow={modalShow}
					login={login}
					setLogin={setLogin}
					signIn={signIn}
					setSignIn={setSignIn}
					setModalShow={setModalShow}
				/>
			)}
		</>
	);
};
export default LoginLayout;
